import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';
import MODELS from '@/constants/models';
import { generateId } from '@/utils/id_utils';

const store = {
  // not reactive campaign-related properties
  campaignCarouselIds: [],
  _storedCampaigns: {}, // [id: campaign obj]
  campaignCarouselIndex: 0,
  campaignScrollPosition: 0,

  get storedCampaigns() {
    return cloneDeep(this._storedCampaigns);
  },

  set storedCampaigns(storedCampaigns) {
    this._storedCampaigns = cloneDeep(storedCampaigns);
  },

  // Reactive state
  state: {
    animateCouponCollapse: true, // So we can disable collapse animation on initial WC load
    canDeleteCoupons: false,
    isLoggedIn: null,
    user: MODELS.user,
    organization: MODELS.organization,
  },

  getTimeZone() {
    return this.state.organization.timezone;
  },

  emptyState() {
    store.state.organization = MODELS.organization;
    store.state.user = MODELS.user;
    store.state.isLoggedIn = false;
  },

  setState(user) {
    this.setCampaignCarouselIds(user.organization.dashboardCampaigns.map(({ id }) => id));
    store.state.organization = omit(user.organization, 'dashboardCampaigns');
    store.state.user = omit(user, 'organization');
    store.state.isLoggedIn = true;
  },

  getScrollPosition() {
    return this.campaignScrollPosition;
  },

  getCampaignCarouselIndex() {
    return this.campaignCarouselIndex;
  },

  containsCampaignId(id) {
    return !!this.storedCampaigns[id];
  },

  getCampaign(id) {
    return cloneDeep(this.storedCampaigns[id] || MODELS.campaign);
  },

  storeCampaign(campaign) {
    this.storedCampaigns = {
      ...this.storedCampaigns,
      [campaign.id]: campaign,
    };
  },

  getCampaignCarouselIds() {
    return cloneDeep(this.campaignCarouselIds);
  },

  setCampaignCarouselIds(campaignIds) {
    this.campaignCarouselIds = new Array(7).fill(null)
      .map((_, i) => campaignIds[i] || this.createNewCampaign().id);
  },

  storeCampaignCarouselIndex(campaignCarouselIndex) {
    this.campaignCarouselIndex = campaignCarouselIndex;
  },

  storeScrollPosition(scrollPosition) {
    this.campaignScrollPosition = scrollPosition;
  },

  updateCoupon(campaignId, coupon, oldId) {
    const newStoredCampaigns = this.storedCampaigns;
    const couponIndex = newStoredCampaigns[campaignId].coupons.findIndex(v => v.id === (oldId || coupon.id));

    if (couponIndex > -1) {
      newStoredCampaigns[campaignId].coupons[couponIndex] = cloneDeep(coupon);
    } else {
      newStoredCampaigns[campaignId].coupons.push(cloneDeep(coupon));
    }

    this.storedCampaigns = newStoredCampaigns;
  },

  deleteCoupon(campaignId, coupon) {
    const newStoredCampaigns = this.storedCampaigns;
    const couponIndex = newStoredCampaigns[campaignId].coupons.findIndex(v => v.id === coupon.id);

    if (couponIndex !== -1) {
      newStoredCampaigns[campaignId].coupons.splice(couponIndex, 1);
      this.storedCampaigns = newStoredCampaigns;
    }
  },

  createNewCampaign() {
    const id = generateId(true);
    const campaign = Object.assign({}, MODELS.campaign, { id });
    this.storeCampaign(campaign);
    return campaign;
  },
};

export default store;
